import type { MatchesQuery, MatchesResponse } from '@ballpeek/api/client'
import type { MatchesSearch } from './search-schema'

import { matchesResponseSchema } from '@ballpeek/api/client'

import { apiClient } from '~/lib/api-client'
import { readPublicFootballResponse } from '~/lib/public-football-read'

export async function listMatches(search: MatchesSearch): Promise<MatchesResponse> {
  const query: MatchesQuery = {
    view: search.view,
    competitionCode: search.competition,
    season: search.season,
    teamId: search.team,
    date: search.date,
    timeZone: search.timeZone,
    page: search.page,
    pageSize: 25,
  }
  const response = await apiClient.api.football.matches.$get({ query })
  return readPublicFootballResponse(response, matchesResponseSchema, 'Matches request failed')
}
